module.exports = __webpack_public_path__ + "static/img/Christmas_Menu_En.d253e94.png";